<template>
    <header class="py-5">
        <div class="container mx-auto">
            <div class="flex justify-between items-center">
                <div class="flex">
                    <router-link tag="a" to="/">
                        <img src="@/assets/img/logo.svg" class="h-12 mr-12">
                    </router-link>
                    <ul class="flex items-center">
                        <li class="mr-12 uppercase text-lg">
                            <router-link tag="a" to="/">О КОМПАНИИ</router-link>
                        </li>
                        <li class="mr-12 uppercase text-lg">
                            <router-link tag="a" to="/">УСЛУГИ</router-link>
                        </li>
                        <li class="mr-12 uppercase text-lg">
                            <router-link tag="a" to="/">ГАЛЕРЕЯ РАБОТ</router-link>
                        </li>
                    </ul>
                </div>
                <div class="flex">
                    <ul class="flex items-center">
                        <li class="mr-12 text-lg font-semibold"><a href="">zakaz@nevado.ru</a></li>
                        <li class="mr-12 text-lg font-semibold"><a href="">8 (812) 439-16-38</a></li>
                    </ul>
                    <div class="burger-menu">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>